import React, { useEffect, useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { useFormik } from 'formik';
import { FaEnvelope, FaEye, FaEyeSlash } from 'react-icons/fa';
import InputField from '../FormFields/InputField';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import ApiService from '../../helper/apiService';
import { APIS } from '../../apis';
import { getUserName } from '../../helper/access';

const JoinRoom = () => {
    const [errorMsg, setErrorMesssage] = useState("");
    const [link, setLink] = useState("");

    useEffect(() => {
        let un = getUserName();
        if (un) {
            formik.setFieldValue("name", un)
        }
    }, [])
 
    const formik = useFormik({
        initialValues: {
            name: '',
            code: '',
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .required('Name is Required'),
            code: Yup.string().required('Join code is required'),
        }),
        onSubmit: async (values, { setSubmitting }) => {
            let room_resp = await joinRoom(values);
            if (room_resp && !room_resp?.error) {
                formik.resetForm();
                setErrorMesssage("")
                window.open(`${process.env.REACT_APP_CLICKNCONECT_REDIRECTION}/${values?.code}`, "_blank");
            } else {
                setLink("")
                setErrorMesssage(room_resp?.message || "Something went wrong")
            }
            setSubmitting(false);
        }
    });

    const joinRoom = async (payload) => {
        const response = await ApiService.get(`${APIS.JOIN_ROOM}/${payload?.code}?userName=${payload?.name}`);
        if(response?.data){
            return response.data
        }else{
            return null;
        }
    }

    return (
        <div className='bodyTabWrap'>
            <div className="pt-5 tabWrap">
                <div className="mt-5 formWrap">
                    <Row>
                        <h3>Join Room</h3>
                        <Col md={12}>
                            <form onSubmit={formik.handleSubmit}>
                                <div className='inputWrap'>
                                    <label>Your Name</label>
                                    <div className="input-group">
                                        <InputField
                                            name="name"
                                            placeholder="Enter your name"
                                            type="text"
                                            value={formik.values.name}
                                            onChange={(e) => {
                                                formik.handleChange(e);
                                                setErrorMesssage("")
                                            }
                                            }
                                            onBlur={formik.handleBlur}
                                            error={formik.errors.name}
                                            touched={formik.touched.name}
                                        />
                                    </div>
                                </div>
                                <div className='inputWrap'>
                                    <label>Join Code</label>
                                    <div className="input-group">
                                        <InputField
                                            name="code"
                                            placeholder="Enter join code"
                                            type={'text'}
                                            value={formik.values.code}
                                            onChange={(e) => {
                                                formik.handleChange(e);
                                                setErrorMesssage("")
                                            }
                                            }
                                            onBlur={formik.handleBlur}
                                            error={formik.errors.code}
                                            touched={formik.touched.code}
                                        />
                                    </div>
                                </div>
                                {errorMsg &&
                                    <div className="errorMessage">
                                        {errorMsg}
                                    </div>
                                }
                                <div className="buttonWrap" style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                                    <Button variant="primary" type="submit">
                                        {formik?.isSubmitting ? "Please wait..." : "Join"}
                                    </Button>
                                    <Button
                                        variant="secondary"
                                        type="button"
                                        onClick={() => {
                                            formik.resetForm()
                                            setLink("");
                                            setErrorMesssage("")
                                        }}
                                    >
                                        Clear
                                    </Button>
                                </div>
                            </form>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default JoinRoom;